import Theme from '@qnpm/q-theme';
const { responsive: { screen } } = Theme;
// 过滤TouchableOpacity不需要的属性
export const EXCLUDES_TOUCHABLE_PROPS = [
    'text',
    'type',
    'size',
    'leftIcon',
    'rightIcon',
    'children'
];
// 不支持的属性 - 需要过滤的外部传入的属性
export const NOT_SUPPORT_PROPS = ['style'];
// 按钮最大宽度 - 左右有24间距
export const BUTTON_MAX_WIDTH = screen.width - 48;
// 按钮点击时的透明度
export const ACTIVE_OPACITY = 0.7;
